import { useTenantContext } from '../tenant-context/index.tsx';

/**
 * @deprecated Unlikely you want this, TODO: rename to useIsVortexOrgAdminOrNonVortexSiteAdmin.
 * Consider checking if user has permission for the action you are protecting.
 * Otherwise you probably want useIsAdmin instead which will check Jira admin permissions.
 * Reach out to #help-jira-cloud-permissions-gordian for more information.
 * https://hello.atlassian.net/wiki/spaces/GORDIAN/blog/2025/04/10/5132389850/What+you+need+to+know+about+site+admin+and+GlobalPermissionManager+in+Jira+Monolith
 */
export const useIsSiteAdmin = (): boolean => {
	const tenantContext = useTenantContext();
	return (tenantContext && tenantContext.isSiteAdmin) || false;
};
